import { YotiFlowType } from '../V2/model/enum/YotiFlowType.enum'

type AgeVerifiableUser = {
  yoti_flow_type?: YotiFlowType | string | null
  is_age_verified?: boolean | number | string | null
}

export type AgeVerificationState = Readonly<{
  hasFullAgeRestriction: boolean
}>

const isAgeVerified = (value: AgeVerifiableUser['is_age_verified']): boolean =>
  value === true || value === 1 || value === '1' || value === 'true'

export const getAgeVerificationState = (
  user?: AgeVerifiableUser | null,
): AgeVerificationState => ({
  hasFullAgeRestriction:
    user?.yoti_flow_type === YotiFlowType.AGE_VERIFICATION &&
    !isAgeVerified(user?.is_age_verified),
})
